import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";

const PrevClosingMonthToDate = () => {
  const prevClosingMTD = useSelector(
    (state) => state.firstRiders.firstTimeRiders?.closing?.prevClosingMTD
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return <NumberDisplay value={prevClosingMTD} disableAnimation={isUserQa} />;
};

export default PrevClosingMonthToDate;
